import React from "react";
import ChakraWrapper from "./styles/ChakraWrapper";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Signin from "./pages/login/Signin";
import Home from "./pages/home/Home";
import Users from "./pages/users/Users";
import User from "./pages/users/User";
import AddUser from "./pages/users/AddUser";
import Assessments from "./pages/assessments/Assessments";
import Requests from "./pages/requests/Requests";
import EditRequest from "./pages/requests/EditRequest";
import ReadOnlyRequest from "./pages/requests/readOnlyRequest";
import AddCandidate from "./pages/addcandidate/AddCandidate";
import AddCandidateBasic from "./pages/addcandidate/AddCandidateBasic";
import Candidates from "./pages/candidates/Candidates";
import Candidate from "./pages/candidates/Candidate";
import Register from "./pages/candidates/Register";
import NewRequestRouter from "./pages/candidates/NewRequestRouter";
import ProfileRouter from "./pages/profile/ProfileRouter";
import Navbar from "./components/Navbar";
import Performance100 from "./components/Performance100";

function App() {
    const location = useLocation();
    const shouldShowNavbar =
        location.pathname !== "/" && location.pathname !== "/performance100";

    return (
        <ChakraWrapper>
            {shouldShowNavbar && <Navbar />}
            <Routes>
                <Route
                    path="/"
                    element={
                        <Signin
                            onLoginSuccess={() =>
                                (window.location.href = "/profile")
                            }
                        />
                    }
                />
                <Route path="/dashboard" element={<Home />} />
                <Route path="/assessments" element={<Assessments />} />
                <Route path="/requests" element={<Requests />} />
                <Route path="/editrequest/:id" element={<EditRequest />} />
                <Route path="/readonlyrequest/:id" element={<ReadOnlyRequest />} />
                <Route path="/addcandidate" element={<AddCandidate />} />
                <Route path="/addcandidatebasic" element={<AddCandidateBasic />} />
                <Route path="/candidates" element={<Candidates />} />
                <Route path="/candidate/:id" element={<Candidate />} />
                <Route path="/register" element={<Register />} />
                <Route path="/newrequest/:clientId/:id" element={<NewRequestRouter />} />
                <Route path="/profile" element={<ProfileRouter />} />
                <Route path="/profile/:clientId" element={<ProfileRouter />} />
                <Route path="/users" element={<Users />} />
                <Route path="/user/:id" element={<User />} />
                <Route path="/adduser" element={<AddUser />} />
                <Route path="/performance100" element={<Performance100 />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </ChakraWrapper>
    );
}

export default App;
